import { render, staticRenderFns } from "./DashboardTooltip.vue?vue&type=template&id=282d5a27&scoped=true"
import script from "./DashboardTooltip.vue?vue&type=script&lang=js"
export * from "./DashboardTooltip.vue?vue&type=script&lang=js"
import style0 from "./DashboardTooltip.vue?vue&type=style&index=0&id=282d5a27&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d5a27",
  null
  
)

export default component.exports